// extracted by mini-css-extract-plugin
export var GreaterSuccessWrapper = "GreaterSuccess-module--GreaterSuccessWrapper--iXZed";
export var GreaterSuccessContent = "GreaterSuccess-module--GreaterSuccessContent--Y1uMY";
export var GreaterSuccessText = "GreaterSuccess-module--GreaterSuccessText--VKsmD";
export var GreaterSuccessVector = "GreaterSuccess-module--GreaterSuccessVector--LejRY";
export var GreaterSuccessGrid = "GreaterSuccess-module--GreaterSuccessGrid--qvR7T";
export var GreaterSuccessGridItem = "GreaterSuccess-module--GreaterSuccessGridItem--KUAsY";
export var GreaterSuccessGridItemContent = "GreaterSuccess-module--GreaterSuccessGridItemContent--6kDWq";